import axios from "axios";

class AdminService {
    async getUsers() {
        const response = await axios.get("/api/admin/users");
        return response.data;
    }

    async getUser(userId) {
        const response = await axios.get(`/api/admin/users/${userId}`);
        return response.data;
    }

    async createUser(user) {
        const response = await axios.post("/api/admin/users", user);
        return response.data;
    }

    async deleteUser(userId) {
        await axios.delete(`/api/admin/users/${userId}`);
    }

    async toggleBlockUser(userId, blocked) {
        const response = await axios.patch(`/api/admin/users/${userId}/block`, { blocked });
        return response.data;
    }

    async impersonateUser(userId) {
        const response = await axios.post("/api/admin/impersonate", { userId });
        return response.data;
    }

    async checkImpersonation() {
        const response = await axios.get("/api/admin/check-impersonation");
        return response.data;
    }

    async stopImpersonation() {
        const response = await axios.post("/api/admin/stop-impersonation");
        return response.data;
    }
}

const adminService = new AdminService();
export default adminService;
